import React from "react";
import SectionHeader from "./SectionHeader";
import TabSwitcher from "./TabSwitcher";

function CampaignTabsSection({
  showTabs = false,
  title,
  description,
  linkText,
  href,
  preserveTrailingSlash = false,
  tabs = [],
  activeTab,
  handleTabChange,
  children,
}) {
  return (
    <div className="flex flex-col gap-4">
      <SectionHeader
        title={title}
        description={description}
        linkText={linkText}
        href={href}
        preserveTrailingSlash={preserveTrailingSlash}
        className="pr-4 lg:pr-0"
      />
      {showTabs && tabs.length > 0 && (
        <TabSwitcher
          tabs={tabs}
          selected={activeTab}
          onChange={handleTabChange}
        />
      )}
      {children}
    </div>
  );
}

export default CampaignTabsSection;
